import { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { api } from "../lib/api";
import { TemplatePreviewDialog, thumbUrl } from "./TemplatePreviewDialog";

export const TemplatePicker = ({ value, onChange }) => {
  const [templates, setTemplates] = useState([]);
  const [zoom, setZoom] = useState(null);
  useEffect(() => { api.get("/templates").then((r) => setTemplates(r.data)); }, []);
  return (
    <>
      <div className="grid grid-cols-5 gap-3 max-h-[340px] overflow-y-auto pr-1" data-testid="template-picker">
        {templates.map((t) => (
          <div key={t.id} className={`group relative rounded-lg overflow-hidden border-2 transition-colors ${value === t.id ? "border-emerald-400" : "border-transparent hover:border-white/20"}`}>
            <button onClick={() => onChange(t.id)} data-testid={`template-option-${t.id}`} title={t.name} className="block w-full text-left">
              <img src={thumbUrl(t.id)} alt={t.name} loading="lazy" decoding="async" className="w-full aspect-[210/297] object-cover object-top bg-white" />
              <p className={`px-1 py-1.5 text-[10px] truncate ${value === t.id ? "text-emerald-400" : "text-slate-400"}`}>{t.name}</p>
            </button>
            <button onClick={() => setZoom(t)} data-testid={`template-zoom-${t.id}`} aria-label={`Preview ${t.name}`}
              className="absolute top-1.5 right-1.5 h-7 w-7 rounded-full bg-black/70 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity">
              <Eye className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
      <TemplatePreviewDialog template={zoom} onClose={() => setZoom(null)} onUse={(id) => { onChange(id); setZoom(null); }} />
    </>
  );
};
